import { useFormController } from '@dreryk/react-common';
import {
   Accordion,
   componentsTranslationKeys,
   FormContent,
   FormPanel,
   FormRouteLeavingPrompt,
   FormValidationSnackbar,
   ModalWidth,
} from '@dreryk/react-components';

import { NewPasswordField } from './fields/NewPasswordField';
import { OldPasswordField } from './fields/OldPasswordField';
import { RepeatNewPasswordField } from './fields/RepeatNewPasswordField';
import { PasswordUpdateFormBean, PasswordUpdateFormController } from './PasswordUpdateForm.types';
import { PasswordUpdateSaveButton } from './PasswordUpdateSaveButton';

export const PASSWORD_UPDATE_FORM_INITIAL_VALUES: PasswordUpdateFormBean = {
   newPassword: '',
   oldPassword: '',
   repeatNewPassword: '',
};

export const PasswordUpdateForm = (): JSX.Element => {
   const { formState, handleSubmit, register, reset }: PasswordUpdateFormController = useFormController(
      PASSWORD_UPDATE_FORM_INITIAL_VALUES
   );

   return (
      <FormPanel>
         <form noValidate autoComplete={'off'}>
            <FormContent testId={'passwordUpdate'}>
               <OldPasswordField register={register} />
               <NewPasswordField register={register} />
               <RepeatNewPasswordField register={register} />
               <PasswordUpdateSaveButton handleSubmit={handleSubmit} reset={reset} />
            </FormContent>
         </form>
         <FormValidationSnackbar formState={formState} />
         <Accordion.Section.ClosingConfirmation
            sectionId={'passwordChange'}
            shouldConfirm={formState.isDirty}
            content={componentsTranslationKeys.formLeavingConfirmation}
            title={componentsTranslationKeys.leaveForm}
            confirmationButtonLabel={componentsTranslationKeys.leave}
            width={ModalWidth.NORMAL}
         />
         <FormRouteLeavingPrompt formState={formState} />
      </FormPanel>
   );
};
